import { connectToStores } from 'fluxible-addons-react';
import { throttle } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import * as defaults from '../../../lib/helpers/defaults';
import UserStore from '../../stores/UserStore';
import canUseStore from '../../util/canUseStore';
import CodeHighlightPrism from '../CodeHighlightPrism';
import { FeedbackSection } from '../FeedbackSection';
import CodeBlockHeader from './Header';
import styles from './styles.module.styl';

class CodeBlock extends React.Component {
  handleUserValueChange = (action, event, selectedOpt) => {
    this.context.executeAction(action, { selectedId: selectedOpt.value });
  };

  handleCopyCode = throttle(
    () => {
      this.context.trackEvent('copy:code-snippet', {
        trackData: this.props.index,
      });
    },
    5000,
    { trailing: false }
  );

  render() {
    const { code, tabPaneFooter, selectedClientId, selectedApiIdentifier, index, language } = this.props;

    // Only show the header if the client id or api id is present in the code
    const isClientIdInCode = code.includes(selectedClientId || defaults.CLIENT_ID);
    const isApiIdInCode = code.includes(selectedApiIdentifier || defaults.API_IDENTIFIER);
    const showHeader = isClientIdInCode || isApiIdInCode;

    return (
      <div className={styles.codeBlock}>
        {showHeader && <CodeBlockHeader isApiIdInCode={isApiIdInCode} isClientIdInCode={isClientIdInCode} />}
        <div className={styles.codeSection}>
          <CodeHighlightPrism code={code} language={language} showCopyButton={true} />
        </div>
        {tabPaneFooter && <div className="tab-pane-footer" dangerouslySetInnerHTML={{ __html: tabPaneFooter }} />}
        <FeedbackSection trackingCode="quickstarts:code-snippet" trackingData={index} />
      </div>
    );
  }
}

CodeBlock.contextTypes = {
  executeAction: PropTypes.func.isRequired,
  getStore: PropTypes.func.isRequired,
  trackEvent: PropTypes.func.isRequired,
};

CodeBlock.defaultProps = {
  tabPaneFooter: null,
};

CodeBlock.propTypes = {
  children: PropTypes.node.isRequired,
  code: PropTypes.string.isRequired,
  tabPaneFooter: PropTypes.string,
  selectedClientId: PropTypes.string,
  selectedApiIdentifier: PropTypes.string,
  index: PropTypes.number,
};

export default connectToStores(CodeBlock, [UserStore], (context) => {
  if (!canUseStore(context)) return {};
  const userStore = context.getStore(UserStore);

  return {
    selectedClientId: userStore.getSelectedClientId(),
    selectedApiIdentifier: userStore.getSelectedApiIdentifier(),
  };
});
